<div class="donationdrive-modal-parent" id="student-consent-modal">
  <div class="ui_modal donationdrive-modal">
    <a href="javascript:void(0)" class="ui_close" (click)="closeIcon()"></a>
    <div class="ui_modal_text">Class Recording Consent</div>
    <div class="ui_modal_content" style="overflow: auto;">
      <div class="sh-grid-1"  [title]="namesList==null">
        <pre style="font-family: inherit;font-size: 16px;white-space: normal;" *ngIf="namesList==null">
          I, {{currUserName}}, consent to Tanzeel to record sessions from time to time for Quality Control purposes.
          No video/camera recording will be done; just the audio and screen content.
          (Users can change preferences from Profile Settings.). <br>
        </pre>
        <pre style="font-family: inherit;font-size: 16px;white-space: normal;" *ngIf="namesList!=null">
          I, {{currUserName}}, consent to Tanzeel to record sessions from time to time for users {{namesList}}, for Quality Control purposes.
          No video/camera recording will be done; just the audio and screen content.
          (Users can change preferences from Profile Settings.). <br>
        </pre>
      </div>
      
      <div class="sh-grid-1" style="margin-bottom: 10px;">
        <div class="ui_input" [class.ui_error]="showError==true">
          <label>Digital Signature ( Type your name: )</label>
          <input type="text" [(ngModel)]="username" placeholder="full Name" (keypress)="usernameChanged($event)">
          <span *ngIf="showError==true" style="padding-right: 20px;"> Enter Name </span>
        </div>
      </div>
      <div class="sh-grid-1" style="margin-bottom: 10px;" *ngIf="forChild==true">
        <div class="ui_input" [class.ui_error]="showPasswordError==true">
          <label>Parental Password *</label>
          <input type="password" [(ngModel)]="parentalPassword" (keypress)="passwordChanged($event)" >
          <span *ngIf="showPasswordError==true" style="padding-right: 20px;"> Enter Password </span>
        </div>
      </div>
    </div>
    <div class="ui_modal_btns">
      <a class="ui_btn ui_btn_primary" href="javascript:void(0)" (click)="action('yes')" >I Consent</a>
      <a class="ui_btn ui_btn_basic" href="javascript:void(0)" (click)="action('no')">I do not Consent</a>
      <a class="ui_btn ui_btn_basic" href="javascript:void(0)" (click)="action('later')">Remind me later</a>

    </div>
  </div>
</div>
